// @core/api/endpoints/authz/expand.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExpandRequest,
  ExpandResponse,
} from '../../../types/authz';

const BASE_PATH = '/authz';

/**
 * Expand permission tree
 * Displays the relationship tree for a given object and relation, showing how permissions are inherited and computed. Useful for debugging authorization issues and understanding permission inheritance paths.
 */
export async function Expand(
  data: ExpandRequest,
  options?: RequestOptions
): Promise<ExpandResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/expand`;
  const requestOptions = options;
  return client.post<ExpandResponse>(requestPath, data, requestOptions);
}
